import React, { useState } from "react";
import styled from "styled-components";

// components
import {
  Button,
  StyledText,
  Span,
  CurveHolder,
} from "../../components/common/basic";

// assest
// import loginheader from "../../../../public/assets/images/dev/loginheader.jpg";
import { Curve, Male } from "../../components/svgs";

// hooks
import { useAuth, useSubscriber } from "../../hooks";

// lib
import { pxToRem, string } from "../../lib/";

const UserInfoScreen = () => {
  const { userDetails } = useAuth();
  const { saveUserData, showLoadingIndicator } = useSubscriber();

  const [state, setState] = useState({
    gender: "",
    occupation: "",
    dob: new Date(),
  });

  const [error, setError] = useState({
    gender: false,
    occupation: false,
  });

  const { assertEmptyString } = string;

  const handleStateChange = (key, value) => {
    setState({ ...state, [key]: value });
    setError({ ...error, [key]: false });
  };

  const generateActiveStyles = (key, option, text) => {
    if (text && state[key] === option) {
      return {
        style: {
          color: "#e31c79",
          textAlign: "center",
          marginTop: 10,
        },
      };
    }

    if (state[key] === option) {
      return {
        fill: "white",
        containerFill: "#e31c79",
        strokeFill: "#e31c79",
        containerStrokeFill: "#e31c79",
      };
    } else {
      return {
        containerStrokeFill: "#e31c79",
        color: "#C8CBCB",
      };
    }
  };

  const styles = generateStyles();

  return (
    <MainHolder>
      {/* <Image src={loginheader} /> */}
      <CurveHolder>
        <Curve />
      </CurveHolder>
      <InputSection>
        <StyledText height={35} margin={0} fontFamily={600} size={24}>
          Finishing up
        </StyledText>
        <StyledText height={24} size={14} fontFamily={300} margin={0}>
          <Span height={24} size={16} margin={0} fontFamily={700}>
            {"Yo! "}
          </Span>
          {userDetails && userDetails["get:FirstName"][0]}
        </StyledText>
        <StyledText size={14} fontFamily={300} height={24} margin={0}>
          Welcome to MTN Pulse
        </StyledText>
        <SelectorHolder>
          <Select>
            <StyledText margin={0} size={14}>
              Gender*
            </StyledText>
            <SelectInner>
              <SelectButton
                onClick={() => {
                  handleStateChange("gender", "male");
                }}
              >
                <Male {...generateActiveStyles("gender", "male")} />
                <StyledText
                  {...generateActiveStyles("gender", "male", true)}
                  align={"center"}
                  margin={8}
                  size={12}
                >
                  Male
                </StyledText>
              </SelectButton>
              <SelectButton
                onClick={() => {
                  handleStateChange("gender", "female");
                }}
              >
                <Male {...generateActiveStyles("gender", "female")} />
                <StyledText
                  {...generateActiveStyles("gender", "female", true)}
                  align={"center"}
                  margin={8}
                  size={12}
                >
                  Female
                </StyledText>
              </SelectButton>
            </SelectInner>
            {error.gender && (
              <StyledText
                fontFamily="bold"
                size={8}
                style={styles.erorrMessage}
              >
                Please make a selection
              </StyledText>
            )}
          </Select>
          <Select>
            <StyledText margin={0} size={14}>
              Occupation*
            </StyledText>
            <SelectInner>
              <SelectButton
                onClick={() => {
                  handleStateChange("occupation", "student");
                }}
              >
                <Male {...generateActiveStyles("occupation", "student")} />
                <StyledText
                  {...generateActiveStyles("occupation", "student", true)}
                  align={"center"}
                  margin={8}
                  size={12}
                >
                  Student
                </StyledText>
              </SelectButton>
              <SelectButton
                onClick={() => {
                  handleStateChange("occupation", "worker");
                }}
              >
                <Male {...generateActiveStyles("occupation", "worker")} />
                <StyledText
                  {...generateActiveStyles("occupation", "worker", true)}
                  align={"center"}
                  margin={8}
                  size={12}
                >
                  Worker
                </StyledText>
              </SelectButton>
            </SelectInner>
            {error.occupation && (
              <StyledText
                fontFamily="bold"
                size={8}
                style={styles.erorrMessage}
              >
                Please make a selection
              </StyledText>
            )}
          </Select>
        </SelectorHolder>
        <label htmlFor="dobinput">
          <StyledText margin={0} size={12}>
            Date of Birth
          </StyledText>
        </label>
        <DOB
          id="dobinput"
          placeHolder="Date of Birth"
          onChange={(e) => {
            setState({ ...state, dob: e?.target?.value?.replaceAll("-", "/") });
          }}
          type="date"
        />
        <ButtonHolder>
          <Button
            margin={10}
            onClick={() => {
              if (!showLoadingIndicator)
                switch (true) {
                  case assertEmptyString(state.gender) &&
                    assertEmptyString(state.occupation):
                    setError({
                      gender: true,
                      occupation: true,
                    });
                    break;

                  case assertEmptyString(state.gender) &&
                    !assertEmptyString(state.occupation):
                    setError({
                      gender: true,
                      occupation: false,
                    });
                    break;

                  case !assertEmptyString(state.gender) &&
                    assertEmptyString(state.occupation):
                    setError({
                      gender: false,
                      occupation: true,
                    });
                    break;

                  case !assertEmptyString(state.gender) &&
                    !assertEmptyString(state.occupation):
                    setError({
                      gender: false,
                      occupation: false,
                    });

                    saveUserData({
                      dob: state.dob,
                      occupation: state.occupation,
                      gender: state.gender,
                    });

                    break;

                  default:
                    break;
                }
            }}
          >
            <StyledText color={"white"}>
              {showLoadingIndicator ? "Loading..." : "Continue"}
            </StyledText>
          </Button>
        </ButtonHolder>
      </InputSection>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Image = styled.img`
  height: 300px;
  width: 100%;
`;

const InputSection = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto 1fr;
  padding: 15px;
  margin-top: -20px;
  background-color: white;
`;

const SelectorHolder = styled.div`
  display: grid;
  grid-auto-flow: column;
`;

const Select = styled.div`
  margin-top: 10px;
`;

const SelectInner = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-items: flex-start;
`;

const SelectButton = styled.div`
  display: grid;
  justify-items: center;
  margin-top: 8px;
`;

const DOB = styled.input`
  margin-top: 10px;
  border: 1px solid black;
  font-family: "Roboto Mono", monospace;
  border-radius: 15px;
  height: 50px;
  padding: 5px;
`;

const ButtonHolder = styled.div`
  display: grid;
  align-content: center;
`;

function generateStyles() {
  return {
    erorrMessage: {
      color: "#EE2737",
    },
  };
}

export default UserInfoScreen;
